import BaseFieldHandler from '../BaseFieldHandler';

export default class SpecialFieldHandler extends BaseFieldHandler {
  static supportedTypes = [];

  handle() {
    const { type } = this.baseConfig;
    throw new Error(
      `No field types supported by SpecialFieldHandler. Type ${type} should be handled by a specialized handler.`,
    );
  }
}
